import React from "react";
import AppFormik from "src/commun/composants/formulaire/formik/AppFormik";
import { FormikValues } from "formik";
import { GenericApiResponse } from "src/app/api/AppApiClient";
import { setPassword } from "src/app/api/AccountApi";
import PasswordUpdateFormContent from "src/pages/infoperso/connexion/module/password/PasswordUpdateFormContent";
import useValidationSchemaPasswordUpdate, { UpdatePassword } from "src/pages/infoperso/connexion/module/password/useValidationSchemaPasswordUpdate";

export type PasswordUpdateFormProps = {
  initialValues: UpdatePassword;
  submitSuccessHandler: (result: GenericApiResponse<any>, values: FormikValues) => void;
  displayCancelBtn?: boolean;
  cancelCallback?: () => void;
};


const PasswordUpdateForm = ({ initialValues, submitSuccessHandler, displayCancelBtn, cancelCallback }: PasswordUpdateFormProps) => {
  const validationSchema = useValidationSchemaPasswordUpdate();

  return (
    <AppFormik
      enableReinitialize
      initialValues={initialValues}
      submitFormAPI={(values: UpdatePassword) => setPassword(values)}
      submitSuccessHandler={submitSuccessHandler}
      validationSchema={validationSchema}
    >
      <PasswordUpdateFormContent displayCancelBtn={displayCancelBtn} cancelCallback={cancelCallback}/>
    </AppFormik>
  );
};

export default PasswordUpdateForm;